/*
 * Prev/next arrows over the main product image.
 *
 * The reference lets you step through the gallery from the main image. Dawn
 * does render slider buttons for the media list, but that list is only a
 * slider on mobile (`slider--mobile`), so on desktop the buttons are hidden and
 * the only way to change image is clicking a thumbnail.
 *
 * Rather than convert the media list into a desktop slider — which fights
 * Dawn's gallery JS — these arrows simply click the previous/next thumbnail.
 * That reuses Dawn's own media-switching path, so variant changes, zoom and
 * keyboard focus all keep working.
 */
(function () {
  function thumbs(gallery) {
    return Array.from(
      gallery.querySelectorAll('.thumbnail-list__item .thumbnail')
    ).filter(function (t) {
      return t.offsetParent !== null;   // skip hidden variant thumbnails
    });
  }

  function build(gallery) {
    if (gallery.dataset.brandArrows) return;
    var list = thumbs(gallery);
    if (list.length < 2) return;         // nothing to step through
    gallery.dataset.brandArrows = '1';

    var media = gallery.querySelector('.product__media-list');
    if (!media) return;
    media.parentElement.classList.add('brand-gallery');

    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'brand-gallery__arrow brand-gallery__arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      b.innerHTML = '<span class="svg-wrapper" aria-hidden="true">'
        + '<svg viewBox="0 0 10 6" fill="none" width="12" height="8">'
        + '<path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.4" '
        + 'stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

      b.addEventListener('click', function () {
        var current = thumbs(gallery);
        var activeIndex = current.findIndex(function (t) {
          return t.getAttribute('aria-current') === 'true'
            || t.closest('.thumbnail-list__item').classList.contains('is-active');
        });
        if (activeIndex < 0) activeIndex = 0;
        var next = dir === 'next'
          ? (activeIndex + 1) % current.length
          : (activeIndex - 1 + current.length) % current.length;
        current[next].click();

        // Keep the active thumbnail in view WITHOUT scrollIntoView — that
        // scrolls the nearest scrollable ancestor, which on this page is the
        // document, so every arrow click jumped back up to the gallery.
        var item = current[next].closest('.thumbnail-list__item');
        var track = item.closest('.thumbnail-list');
        if (track && track.scrollWidth > track.clientWidth) {
          track.scrollLeft = item.offsetLeft - (track.clientWidth - item.offsetWidth) / 2;
        }
      });

      media.parentElement.appendChild(b);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('media-gallery').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
